<template>
  <InputComponent v-bind="$attrs" :icon="['fal', 'palette']">
    <template #default>
      <input
        type="color"
        class="elder-input__element"
        v-model="comp"
        :style="{ height: `${height}px` }"
      />
    </template>
  </InputComponent>
</template>

<script>
import { InputComponent } from 'vue-elder-input'
import { ValueComp } from '../utils'

export default {
  props: ['value'],
  data() {
    return {
      height: 80,
    }
  },
  computed: {
    comp: ValueComp(),
  },
  components: {
    InputComponent,
  },
}
</script>
